import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgInitiative = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <circle cx={8} cy={8} r={3} fill={_.color} />
  </svg>
);
const ForwardRef = forwardRef(SvgInitiative);
export default ForwardRef;
